import { is } from "superstruct";
import { EnvironmentStruct } from "@features/ottPurchase/types/GetOfferApi";
import { usePostEntitlementMutation } from "@features/ottPurchase/services/ottPurchaseApi";
import { useNavigate } from "react-router";
import { useEffect } from "react";

const TIME_BEFORE_REDIRECTION = 5000; // 5 seconds

export interface UseHandleSuccessParams {
  offerId: string;
  locale: string;
  env: string;
  redirectUrl: string;
}

export const useHandleSuccess = ({
  offerId,
  locale,
  env,
  redirectUrl,
}: UseHandleSuccessParams) => {
  const [postEntitlement] = usePostEntitlementMutation();
  const navigate = useNavigate();

  useEffect(() => {
    postEntitlement({
      offerId: offerId,
      locale,
      environment: is(env, EnvironmentStruct) ? env : undefined,
    })
      .unwrap()
      .then(() => {
        setTimeout(() => {
          window.location.href = redirectUrl;
        }, TIME_BEFORE_REDIRECTION);
      })
      .catch(() => {
        navigate("/error-page");
      });
  }, [env, locale, navigate, offerId, postEntitlement, redirectUrl]);
};
